import(/* webpackMode: "eager" */ "/vercel/path0/src/app/politicas/page.tsx");
